import { Button, cn } from "web-design-system";
import transactEmptyImg from "../../assets/images/internal-empty.png";

/**
 * Empty state for the internal holdings tab. Copy and the call to action
 * differ per host app (partners opens the transaction dialog, clients goes
 * to the funds catalog), so those come in as props.
 *
 * `orientation` picks between the wide layout used beside a table and a
 * stacked one — graphic, copy, then action, all centred — for narrower
 * columns.
 */
export function NoInternalHoldings({
  title,
  description,
  actionLabel,
  onAction,
  orientation = "horizontal",
}: {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  orientation?: "horizontal" | "vertical";
}) {
  const isVertical = orientation === "vertical";

  const graphic = (
    <div
      className={cn(
        "flex justify-center items-center w-75 h-40 shrink-0",
        isVertical && "w-auto"
      )}
    >
      <img className="h-full aspect-auto" src={transactEmptyImg} alt="" />
    </div>
  );

  return (
    <div
      className={cn(
        "flex flex-1 bg-card border border-border rounded-lg items-center",
        isVertical ? "flex-col justify-center p-10" : "flex-row"
      )}
    >
      <div
        className={cn(
          "flex items-center flex-1",
          isVertical ? "flex-col justify-center gap-8" : "justify-center gap-24"
        )}
      >
        {isVertical && graphic}
        <div
          className={cn(
            "flex flex-col shrink-0",
            isVertical
              ? "items-center text-center w-full max-w-125"
              : "items-start w-100"
          )}
        >
          <span className="text-xl font-semibold">{title}</span>
          <span className="mt-2 text-muted-foreground">{description}</span>
          <Button
            onClick={onAction}
            className={cn("mt-12", isVertical && "mt-8")}
            size="lg"
            variant="outline"
          >
            {actionLabel}
          </Button>
        </div>
        {!isVertical && graphic}
      </div>
    </div>
  );
}
